<template>
  <div>
    <div class="wf-flex wf-items-center">
      <button
        @click.prevent="toggleHeader"
        :class="hasHeader ? ['wf-bg-indigo-600 '] : ['wf-bg-gray-200']"
        class="wf-h-6 wf-w-6 wf-rounded wf-border wf-text-xs wf-items-center wf-flex wf-justify-center"
      ><i v-show="hasHeader" class="fas fa-check wf-text-white"></i></button>
      <span class="wf-ml-2 wf-text-xs wf-uppercase wf-font-bold wf-tracking-wide wf-text-gray-800">Header</span>
    </div>
  </div>
</template>

<script>
  import {HeaderFactory} from '../../factories/HeaderFactory'
  import ArrayManipulation from '../../mixins/ArrayManipulation'
  export default {
    mixins: [ArrayManipulation],
    computed: {
      hasHeader() {
        return !! this.$store.getters['headerModule/elements']()
      },
    },
    methods: {
      toggleHeader() {
        this.hasHeader ? this.removeHeader() : this.addHeader()
      },
      removeHeader() {
        this.addToObject('layoutModule', null, 'header')
      },
      addHeader() {
        this.addToObject('layoutModule', (new HeaderFactory).create(), 'header')
      }
    }
  }
</script>